import { render, staticRenderFns } from "./MarketplaceItem.vue?vue&type=template&id=19e9f7e1&scoped=true&"
import script from "./MarketplaceItem.vue?vue&type=script&lang=js&"
export * from "./MarketplaceItem.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceItem.vue?vue&type=style&index=0&id=19e9f7e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e9f7e1",
  null
  
)

export default component.exports